import { createAction, props } from '@ngrx/store';
import { IBenchmark, IBenchmarkSearchRequest } from '../models/benckmark.model';

export const loadSearchBenchmarks = createAction('[SearchBenchmark] Load SearchBenchmarks', props<{ request: IBenchmarkSearchRequest }>());

export const loadSearchBenchmarksSuccess = createAction(
  '[SearchBenchmark] Load SearchBenchmarks Success',
  props<{ response: IBenchmark[] }>()
);

export const loadSearchBenchmarksFailure = createAction('[SearchBenchmark] Load SearchBenchmarks Failure', props<{ error: Error | any }>());
